import { MetaDataContext } from '@uturn/portal/context';
import { getCurrencySign } from '@uturn/portal/utils';
import {
	FormControl,
	FormItem,
	FormMessage,
	Input,
	InputAddon,
} from '@uturn/ui-kit';
import { useContext } from 'react';
import type { ControllerRenderProps, FieldValues } from 'react-hook-form';

export const PriceInput = ({
	field,
	currencyCode,
	placeholder = 'New value',
}: {
	field: ControllerRenderProps<FieldValues, string>;
	currencyCode: string;
	placeholder?: string;
}) => {
	const { shipmentMetaData } = useContext(MetaDataContext);

	const currencies = shipmentMetaData?.currencies;
	return (
		<FormItem>
			<FormControl>
				<div className="relative">
					<Input
						className="pl-6"
						placeholder={placeholder}
						value={field.value ?? ''}
						onChange={(e) => {
							const raw = e.target.value;
							field.onChange(raw === '' ? '' : e.target.valueAsNumber);
						}}
						type="number"
					/>
					<InputAddon type="leading">
						<span className="text-secondary-500 sm:text-sm">
							{getCurrencySign(currencyCode, currencies)}
						</span>
					</InputAddon>
				</div>
			</FormControl>
			<FormMessage />
		</FormItem>
	);
};
